import { detectLocale } from "@blockdaemon/widget-host";
import { i18n } from "@lingui/core";
import type { ReactNode } from "react";
import { useEffect } from "react";

import { useTokenizationWidgetConfig } from "../../providers/tokenization-widget-config-provider";

interface TokenizationLocaleConfigWrapperProps {
  children: ReactNode;
}

/**
 * Syncs Lingui locale from tokenization customer config (`appearance.locale`).
 * Must render under {@link TokenizationWidgetConfigProvider}.
 */
export function TokenizationLocaleConfigWrapper({
  children,
}: TokenizationLocaleConfigWrapperProps) {
  const { appearance } = useTokenizationWidgetConfig();
  const configLocale = appearance?.locale;

  useEffect(() => {
    if (configLocale) {
      const locale = detectLocale(configLocale);
      if (i18n.locale !== locale) {
        i18n.activate(locale);
        localStorage.setItem("widget-locale", locale);
      }
    }
  }, [configLocale]);

  return <>{children}</>;
}
